import { SponsoredProductType } from 'features/products/types';
import { Product } from 'common/components/product-card/types';
import { getProductBelongFromSource } from 'common/utils/analytics';

export const getAnalyticsData = (elementBlock: string, product: Product) => {
  if (elementBlock === 'recommendedProducts / basket') {
    return {
      brand: product.brand ?? null,
      category: product.compareCategory?.name ?? null,
      division: null,
      elementBlock,
      isMonetization: (product as SponsoredProductType)?.monetization ?? null,
      productBelong: getProductBelongFromSource(product.source),
      productDiscount: product.price.discount_percent ?? null,
      productFamilyId: product.compareCategory?.familyId ?? null,
      productTag: null,
      subdivision: null,
    };
  }

  return {};
};
